export const setCookie = (name, value, days = 365) => {
    let expires = ''
    if (days) {
        const date = new Date()
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000) // calculate for the specified number of days
        expires = `; expires=${date.toUTCString()}` // set expiration date of the cookie
    }
    document.cookie = `${name}=${value || ''}${expires}; path=/` // set the cookie
}
